(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (() => {
 const item=document.querySelector('[data-tm-extension-price]');
 if(!item)return;
 const end=Date.parse(item.dataset.offerEnd),server=Number(item.dataset.serverNow)*1000,mounted=performance.now();
 const refresh=()=>{if(server+performance.now()-mounted>=end)window.location.reload();};
 setTimeout(refresh,Math.max(100,end-server+250));
 document.addEventListener('visibilitychange',refresh);window.addEventListener('pageshow',refresh);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tm-bundle-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tm-bundle-selector')) {
    customElements.define('tm-bundle-selector', class extends HTMLElement {
      connectedCallback() {
        this.start = () => this.initialize();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
        else this.initialize();
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        this.root = this.closest('product-info');
        this.quantity = this.root?.querySelector('input.quantity__input[name="quantity"]');
        if (!this.quantity) return;
        this.initialized = true;
        this.initialTime = Number(this.dataset.now) * 1000;
        this.mounted = performance.now();
        this.price = Number(this.dataset.unitPrice);
        this.requested = Number(this.quantity.value) || 1;
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'hu-HU', {
          style: 'currency', currency: this.dataset.currency || 'HUF', minimumFractionDigits: 0, maximumFractionDigits: 2
        });
        this.onChange = (event) => {
          if (event.target.matches('.tm-bundle-selector__radio')) {
            this.requested = Number(event.target.value);
            this.applyQuantity();
          } else if (event.target === this.quantity) {
            this.requested = Number(this.quantity.value) || 1;
            this.sync();
          }
        };
        this.root.addEventListener('change', this.onChange);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.root.dataset.section) return;
            if (data.variant) this.price = Number(data.variant.price);
            this.applyQuantity();
            this.refreshPrices();
          });
          this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => queueMicrotask(() => {
            if (this.isConnected) this.sync();
          }));
        }
        this.sync();
        this.refreshPrices();
      }

      applyQuantity() {
        const min = Number(this.quantity.min) || 1;
        const max = this.quantity.max === '' ? Infinity : Number(this.quantity.max);
        const step = Number(this.quantity.step) || 1;
        const clamped = Math.min(max, Math.max(min, this.requested));
        this.quantity.value = String(min + Math.floor((clamped - min) / step) * step);
        this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }

      sync() {
        const value = Number(this.quantity.value);
        const min = Number(this.quantity.min) || 1;
        const max = this.quantity.max === '' ? Infinity : Number(this.quantity.max);
        const step = Number(this.quantity.step) || 1;
        this.querySelectorAll('.tm-bundle-selector__radio').forEach((input) => {
          const count = Number(input.value);
          input.checked = count === value;
          input.disabled = count < min || count > max || (count - min) % step !== 0;
        });
      }

      refreshPrices() {
        clearTimeout(this.timer);
        const now = this.initialTime + performance.now() - this.mounted;
        const end = Number(this.dataset.start) * 1000;
        const sale = this.dataset.productId === '9881631686995' && now >= Number(this.dataset.saleStart) * 1000 && now < end;
        const notice = this.querySelector('[data-bundle-sale]');
        if (notice) notice.hidden = !sale;
        this.querySelectorAll('[data-bundle-option]').forEach((option) => {
          const count = Number(option.dataset.bundleOption);
          const percent = sale ? 50 : count >= 3 ? 25 : count === 2 ? 15 : 0;
          const unit = this.price - Math.round(this.price * percent / 100);
          option.querySelector('[data-bundle-unit]').textContent = this.formatter.format(unit / 100);
          option.querySelector('[data-bundle-total]').textContent = this.formatter.format(unit * count / 100);
          const original = option.querySelector('[data-bundle-original]');
          original.textContent = this.formatter.format(this.price * count / 100);
          original.hidden = percent === 0 || sale;
          const detail = option.querySelector('[data-bundle-percent]');
          const suffix = detail.dataset.suffix || (detail.dataset.suffix = detail.textContent.replace(/^\s*·\s*\d+/, ''));
          detail.textContent = ' · ' + percent + suffix;
          detail.hidden = percent === 0 || sale;
        });
        if (now < end) this.timer = setTimeout(() => this.refreshPrices(), Math.min(end - now + 100, 2147483647));
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.root?.removeEventListener('change', this.onChange);
        this.unsubscribeVariant?.();
        this.unsubscribeQuantity?.();
        clearTimeout(this.timer);
        this.initialized = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tm-exit-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('tm-exit-offer');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';
    const dialog = root.querySelector('dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const apply = root.querySelector('.tm-exit-apply');
    const preview = root.dataset.preview === 'true';
    const start = Date.parse(root.dataset.start);
    const serverNow = Number(root.dataset.serverNow) * 1000;
    const mountedAt = performance.now();
    const elapsed = () => performance.now() - mountedAt;
    const started = () => Number.isFinite(start) && Number.isFinite(serverNow) && serverNow + elapsed() >= start;
    const storageKey = 'tm_offer_maradj15_seen';
    const cooldown = 7 * 24 * 60 * 60 * 1000;
    let shown = false;
    let lastFocus = null;
    const privacy = () => window.Shopify && window.Shopify.customerPrivacy;
    const storageAllowed = () => !!(privacy() && privacy().marketingAllowed());
    const stamp = () => serverNow + elapsed();
    const recentlyShown = () => {
      if (!storageAllowed()) return true;
      try {
        const value = Number(localStorage.getItem(storageKey));
        return value > 0 && stamp() - value < cooldown;
      } catch (_) { return true; }
    };
    const visible = element => !!element && !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    const blocked = () => visible(document.getElementById('shopify-pc__banner')) || Array.from(document.querySelectorAll('dialog[open],details[open].menu-drawer-container,cart-drawer.active')).some(el => el !== dialog);
    const editing = () => !!document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
    const open = () => {
      if (!started() || preview || shown || blocked() || editing()) return;
      if (!storageAllowed() || recentlyShown() || elapsed() < 30000) return;
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      shown = true;
      lastFocus = document.activeElement;
      root.querySelector('.tm-exit-preview').hidden = !preview;
      dialog.showModal();
      if (storageAllowed() && !preview) {
        try { localStorage.setItem(storageKey, String(stamp())); } catch (_) {}
      }
    };
    const close = () => dialog.close();
    root.querySelector('.tm-exit-close').addEventListener('click', close);
    root.querySelector('.tm-exit-dismiss').addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
    dialog.addEventListener('close', () => { if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus(); });
    if (preview) apply.addEventListener('click', event => { event.preventDefault(); });
    document.addEventListener('mouseleave', event => {
      if (event.relatedTarget !== null || event.clientY > 0) return;
      if (event.clientX < 0 || event.clientX > window.innerWidth) return;
      open();
    });
    document.addEventListener('visitorConsentCollected', () => {
      if (!storageAllowed() && dialog.open) dialog.close();
      if (!storageAllowed()) { try { localStorage.removeItem(storageKey); } catch (_) {} }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tm-extended-offer-banner"] && !Shopify.designMode) return;
  try {
    (() => {
 const bar=document.querySelector('.tm-extension-banner');if(!bar)return;
 const end=Date.parse('2026-10-26T23:00:00Z'),server=Number(bar.dataset.serverNow)*1000,mounted=performance.now();
 const expire=()=>{if(server+performance.now()-mounted>=end)window.location.reload();};
 setTimeout(expire,Math.max(100,end-server+250));
 document.addEventListener('visibilitychange',expire);window.addEventListener('pageshow',expire);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tm-prior-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tm-price-history')) {
  customElements.define('tm-price-history', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.querySelector('[data-history-open]').addEventListener('click', () => this.dialog.showModal());
      this.querySelector('[data-history-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
      const notice = this.querySelector('[data-tm-pillow-offer]');
      if (!notice) return;
      const end = Date.parse(notice.dataset.ends);
      const server = Number(notice.dataset.serverNow) * 1000;
      const mounted = performance.now();
      this.refresh = () => { if (server + performance.now() - mounted >= end) window.location.reload(); };
      this.timer = setTimeout(this.refresh, Math.max(100, end - server + 250));
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.refresh) {
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
